import gql from 'graphql-tag'

export const LIST_INTERESTS = gql`
  query ListInterestsQuery($limit: Int!, $offset: Int!, $orderBy: String!, $isDelete: Float!){
    listInterests(orderBy: $orderBy){
      results(limit: $limit, offset: $offset){
        id
        name
        profiles(isDelete: $isDelete){
          id
        }
      }      
      totalCount
    }
  } 
`

export const LIST_INTEREST_CONTACTS_WITH_WORK = gql`
  query ListInterestContactsQuery($limit: Int!, $offset: Int!, $interestId: Float!, $orderBy: String!, , $profileIsDelete: Float!){ 
    listInterestProfile(interestId: $interestId, orderBy: $orderBy, profileIsDelete: $profileIsDelete){
      results(limit: $limit, offset: $offset){
        profile{
          id
          number
          name
          lastName
          avatarImg
          gender
          facebookUrl
          instagramUrl
          lastSmsBody
          hasUnread
          pendingStatus
          profileWorkHistory{
            id
            organization{
              id
              name
            }
            title{
              id
              name
            }
          }
        }
      }
      totalCount
    }
  }
`

export const LIST_EDIT_INTEREST_CONTACTS = gql`
  query ListInterestContactsQuery($limit: Int!, $offset: Int!, $interestId: Float!, $orderBy: String!, , $profileIsDelete: Float!){ 
    listInterestProfile(interestId: $interestId, orderBy: $orderBy, profileIsDelete: $profileIsDelete){
      results(limit: $limit, offset: $offset){
        profile{
          id
          number
          name
          lastName
          avatarImg
          gender
          facebookUrl
          instagramUrl
          birthyear
          description
          categorySet{
            id
            name
          }
          groupSet{
            id
            name
          }
          bdayTags (name: "birthday"){
            id
            intValue
            strValue
            name
          }
          profileWorkHistory{
            id
            organization{
              id
              name
            }
            title{
              id
              name
            }                     
          }
        }
      }
      totalCount
    }
  }
`
